// eslint-disable-next-line import/no-cycle
import { AnyDocument, LenientReadingPosition } from '../../../types';
import makeLogger from '../../../utils/makeLogger';
// eslint-disable-next-line import/no-cycle
import { globalState, updateState } from '../../models';

const logger = makeLogger(__filename, { shouldLogToNewRelic: true, shouldLog: true });

export const addExperiencePoints = async (
  newPosition: LenientReadingPosition,
  doc: AnyDocument,
  totalWordsInDoc: number,
  correlationId?: string,
): Promise<void> => {
  const docId = doc.id;
  const previousPosition = doc.readingPosition;

  // const isChunked = doc.source_specific_data?.epub?.is_chunked ?? false;

  if (!docId) {
    logger.error(`No doc ID Found when adding experience`);
    return;
  }

  // Get current state
  const state = globalState.getState();

  // Check if XP tracking is disabled in developer settings
  const isXpTrackingDisabled = state.client.mobileDeveloperSettings.disableXpTracking;
  if (isXpTrackingDisabled) {
    logger.info('XP tracking is disabled in developer settings, not adding experience points');
    return;
  }

  const progressDelta = (newPosition.scrollDepth ?? 0) - (previousPosition?.scrollDepth ?? 0);
  let wordsRead = totalWordsInDoc * progressDelta;

  if (wordsRead <= 0) {
    logger.info('Words read is negative, dont add XP ', { docId, wordsRead });
    return;
  }
  if (wordsRead > 1500) {
    // Set a cap of 1500 words read in case there was some bug in the progress calculation or a user jumped far using the TOC
    wordsRead = 1500;
  }

  logger.info(`adding ${wordsRead} of experience`);

  await updateState(
    (state) => {
      if (!state.persistent.experience || state.persistent.experience < 0) {
        state.persistent.experience = 0;
      }
      state.persistent.experience += wordsRead;
      state.persistent.experience = Math.round(state.persistent.experience);
    },
    { userInteraction: 'null', eventName: 'add-experience-points', isUndoable: false, correlationId },
  );
};
